import React from "react";
import styled, { css } from "styled-components";

import Media from "css/Media";

const Button = (props) => {
  return (
    <StyledDiv
      className={props.className}
      onClick={props.onClick}
      negative={props.negative ? 1 : 0}
      disabled={props.disabled}
    >
      {props.children}
    </StyledDiv>
  );
};

export default Button;

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
  border: ${(props) =>
    props.negative
      ? props.disabled
        ? "none"
        : `1px solid ${props.theme.colors.link}`
      : "none"};
  border-radius: 50px;
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.input
      : props.negative
      ? props.theme.colors.negative
      : props.theme.colors.button};
  color: ${(props) =>
    props.disabled
      ? props.theme.colors.negative
      : props.negative
      ? props.theme.colors.link
      : props.theme.colors.negative};
  transition: background-color 0.2s ease;
  text-align: center;
  padding: ${(props) => props.theme.spacing.contentXS}
    ${(props) => props.theme.spacing.contentS};
  font-size: 12px;
  font-weight: 500;

  svg {
    align-self: center;
  }

  ${(props) =>
    !props.disabled &&
    css`
      &:hover,
      &:active,
      &:focus {
        background-color: ${(props) =>
          props.negative ? props.theme.colors.button : props.theme.colors.link};
        color: ${(props) => props.theme.colors.negative};

        svg {
          fill: ${(props) => props.theme.colors.negative};
        }
      }
    `}

  ${Media.greaterThan("s")`
        padding: 25px 38px;
    `}
    
    ${Media.greaterThan("m")`
        font-size: 14px;
    `}
`;
